module.exports = __webpack_public_path__ + "media/src/images/orderEx02-6b26222e9b7dc59536e090a87c38b01a.gif";